module.exports = __webpack_public_path__ + "img/5.92662e11.svg";